import { MENUS_ENDPOINTS } from "./endpoints";
import type { ServerGeneratedMenu } from "./types";
import { apiRequestWithData } from "../shared";

/**
 * Asks the server to build the week. Diet and allergens are read on the server from the stored
 * preferences, so only the week travels in the request. Nothing is saved.
 */
export default async function generateServerMenu(weekStart: string): Promise<ServerGeneratedMenu> {
  return apiRequestWithData<ServerGeneratedMenu>(MENUS_ENDPOINTS.GENERATE, {
    method: "POST",
    body: JSON.stringify({ week_start: weekStart }),
  });
}
